module.exports = __webpack_public_path__ + "img/eye-dropper-half.8f05c608.svg";